module.exports = __webpack_public_path__ + "img/eodb.3c1ecae3.png";